const caminhoArquivo = (modulo, arquivo) =>
    `/treinamento/mercado-pago/modulo-${String(modulo).padStart(2, "0")}/${arquivo}`

export const moduloUm = [
    {
        "id": "1",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "path": caminhoArquivo(1, "Mercado Pago_Mercado Financeiro_Parte I_v2.pdf"),
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "path": caminhoArquivo(1, "Mercado Pago_Mercado Financeiro_Parte II_1.pdf"),
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Treinamento.pdf",
        "path": caminhoArquivo(1, "Treinamento.pdf"),
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "Estruturacao de Fundos_Aplicacao em Aula.pdf",
        "path": caminhoArquivo(1, "Estruturacao de Fundos_Aplicacao em Aula.pdf"),
        "type": "pdf"
    },
    {
        "id": "5",
        "arquivo": "FIDC-Lamina-v.diagramada.pdf",
        "path": caminhoArquivo(1, "FIDC-Lamina-v.diagramada.pdf"),
        "type": "pdf"
    },
    {
        "id": "6",
        "arquivo": "LAMINA MULTIMERCADO.pdf",
        "path": caminhoArquivo(1, "LAMINA MULTIMERCADO.pdf"),
        "type": "pdf"
    },
    {
        "id": "7",
        "arquivo": "Regulamento FIDC.pdf",
        "path": caminhoArquivo(1, "Regulamento FIDC.pdf"),
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "Regulamento Multimercado.pdf",
        "path": caminhoArquivo(1, "Regulamento Multimercado.pdf"),
        "type": "pdf"
    },
    {
        "id": "9",
        "arquivo": "Mercado Pago_Mercado Financeiro_Derivativos.pdf",
        "path": caminhoArquivo(1, "Mercado Pago_Mercado Financeiro_Derivativos.pdf"),
        "type": "pdf"
    },
    {
        "id": "10",
        "arquivo": "Derivativos.xlsx",
        "path": caminhoArquivo(1, "Derivativos.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "11",
        "arquivo": "cotas securitizacao.xlsx",
        "path": caminhoArquivo(1, "cotas securitizacao.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "12",
        "arquivo": "Mercado Pago_Mercado Financeiro_Resumo.pdf",
        "path": caminhoArquivo(1, "Mercado Pago_Mercado Financeiro_Resumo.pdf"),
        "type": "pdf"
    },
]

export const moduloDois = [
    {
        "id": "1",
        "arquivo": "C2P_Modulo2.pdf",
        "path": caminhoArquivo(2, "C2P_Modulo2.pdf"),
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "demonstracao_financeira_MPB_062025_FINAL.pdf",
        "path": caminhoArquivo(2, "demonstracao_financeira_MPB_062025_FINAL.pdf"),
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Exemplo.xlsx",
        "path": caminhoArquivo(2, "Exemplo.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "4",
        "arquivo": "JPM_DemonstracoesConsolidadas_IFRS.pdf",
        "path": caminhoArquivo(2, "JPM_DemonstracoesConsolidadas_IFRS.pdf"),
        "type": "pdf"
    },
]

export const moduloTres = [
    {
        "id": "1",
        "arquivo": "Gestao de Risco.pdf",
        "path": caminhoArquivo(3, "Gestao de Risco.pdf"),
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Derivativos_Sadia.xlsx",
        "path": caminhoArquivo(3, "Derivativos_Sadia.xlsx"),
        "type": "xlsx"
    },
]

export const moduloQuatro = [
    {
        "id": "1",
        "arquivo": "Modulo RM - parte 1.pdf",
        "path": caminhoArquivo(4, "Modulo RM - parte 1.pdf"),
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Dados para exercicios - parte 01.xlsx",
        "path": caminhoArquivo(4, "Dados para exercicios - parte 01.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "3",
        "arquivo": "LC de RM - 01.pdf",
        "path": caminhoArquivo(4, "LC de RM - 01.pdf"),
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "Quiz 01 - Risco de Mercado - Conceitos Introdutórios",
        "path": "https://forms.office.com/r/5u3r0z9TUt",
        "type": "link"
    },
    {
        "id": "5",
        "arquivo": "LC de RM - 02.pdf",
        "path": caminhoArquivo(4, "LC de RM - 02.pdf"),
        "type": "pdf"
    },
    {
        "id": "6",
        "arquivo": "Quiz 02 - Conceitos Matemáticos e Estatísticos",
        "path": "https://forms.office.com/r/ihq5FnmpvY",
        "type": "link"
    },
    {
        "id": "7",
        "arquivo": "Modulo RM - parte 2.pdf",
        "path": caminhoArquivo(4, "Modulo RM - parte 2.pdf"),
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "LC de RM - 03.pdf",
        "path": caminhoArquivo(4, "LC de RM - 03.pdf"),
        "type": "pdf"
    },
    {
        "id": "9",
        "arquivo": "Quiz 03 - Estimativa Volatilidade",
        "path": "https://forms.office.com/r/kjTzNyvVwY",
        "type": "link"
    },
    {
        "id": "10",
        "arquivo": "LC de RM - 04.pdf",
        "path": caminhoArquivo(4, "LC de RM - 04.pdf"),
        "type": "pdf"
    },
    {
        "id": "11",
        "arquivo": "Quiz 04 - Introdução Opções",
        "path": "https://forms.office.com/r/VaAzJGQnPg",
        "type": "link"
    },
    {
        "id": "12",
        "arquivo": "LC de RM - 05",
        "path": caminhoArquivo(4, "LC de RM - 05.pdf"),
        "type": "pdf"
    },
    {
        "id": "13",
        "arquivo": "Quiz 05 - BS e RF",
        "path": "https://forms.office.com/r/vF0aC3kTHQ",
        "type": "link"
    },
    {
        "id": "14",
        "arquivo": "Modulo RM - parte 3",
        "path": caminhoArquivo(4, "Modulo RM - parte 3.pdf"),
        "type": "pdf"
    },
    {
        "id": "15",
        "arquivo": "LC de RM - 06",
        "path": caminhoArquivo(4, "LC de RM - 06.pdf"),
        "type": "pdf"
    },
    {
        "id": "16",
        "arquivo": "Quiz 06 - HEDGE",
        "path": "https://forms.office.com/r/s3wg7LgJYq",
        "type": "link"
    },
    {
        "id": "17",
        "arquivo": "LC de RM - 07",
        "path": caminhoArquivo(4, "LC de RM - 07.pdf"),
        "type": "pdf"
    },
    {
        "id": "18",
        "arquivo": "Quiz 07 - VaR",
        "path": "https://forms.office.com/r/qBTSxtC1Ev",
        "type": "link"
    },
    {
        "id": "19",
        "arquivo": "Modulo RM - Estudo de Caso",
        "path": caminhoArquivo(4, "Modulo RM - Estudo de Caso.pdf"),
        "type": "pdf"
    },
]

export const moduloCinco = [
    {
        "id": "1",
        "arquivo": "Risco de Liquidez.pdf",
        "path": caminhoArquivo(5, "Risco de Liquidez.pdf"),
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Quiz 01",
        "path": "https://forms.office.com/r/eQX7iXsskf",
        "type": "link"
    },
    {
        "id": "3",
        "arquivo": "Estudo de Caso.pdf",
        "path": caminhoArquivo(5, "Estudo de Caso.pdf"),
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "LA VAR.xls",
        "path": caminhoArquivo(5, "LA VAR.xls"),
        "type": "xls"
    },
    {
        "id": "5",
        "arquivo": "Estudo de Caso Resolvido.pdf",
        "path": caminhoArquivo(5, "Estudo de Caso Resolvido.pdf"),
        "type": "pdf"
    },
]

export const moduloSeis = [
    {
        "id": "1",
        "arquivo": "RC - parte 1.pdf",
        "path": caminhoArquivo(6, "RC - parte 1.pdf"),
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "LC de RC - 01.pdf",
        "path": caminhoArquivo(6, "LC de RC - 01.pdf"),
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Quiz 01 - Introdução ao Risco de Crédito",
        "path": "https://forms.office.com/r/sxsr887u6p",
        "type": "link"
    },
    {
        "id": "4",
        "arquivo": "LC de RC - 02.pdf",
        "path": caminhoArquivo(6, "LC de RC - 02.pdf"),
        "type": "pdf"
    },
    {
        "id": "5",
        "arquivo": "RC - formato c2p - parte 2.pdf",
        "path": caminhoArquivo(6, "RC - formato c2p - parte 2.pdf"),
        "type": "pdf"
    },
    {
        "id": "6",
        "arquivo": "Quiz de RC - 02",
        "path": "https://forms.office.com/r/xy8XnvzLBJ",
        "type": "link"
    },
    {
        "id": "7",
        "arquivo": "RC - formato c2p - parte 3.pdf",
        "path": caminhoArquivo(6, "RC - formato c2p - parte 3.pdf"),
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "Quiz de RC - 03",
        "path": "https://forms.office.com/r/LX6mYHNwqw",
        "type": "link"
    },
    {
        "id": "9",
        "arquivo": "Quiz de RC - 05",
        "path": "https://forms.office.com/r/qfq7iBheTm",
        "type": "link"
    },
    {
        "id": "10",
        "arquivo": "RC - formato c2p - parte 4",
        "path": caminhoArquivo(6, "RC - formato c2p - parte 4.pdf"),
        "type": "pdf"
    },
    {
        "id": "11",
        "arquivo": "Quiz de RC - 06",
        "path": "https://forms.office.com/r/Qpedv9YG5f",
        "type": "link"
    },
]

export const moduloSete = [
    {
        "id": "1",
        "arquivo": "LC Contraparte - 01.pdf",
        "path": caminhoArquivo(7, "LC Contraparte - 01.pdf"),
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "RC Contraparte - parte 1.pdf",
        "path": caminhoArquivo(7, "RC Contraparte - parte 1.pdf"),
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Quiz – Introdução ao Risco de Crédito de Contraparte",
        "path": "https://forms.office.com/r/dJp8cBR5qU",
        "type": "link"
    },
    {
        "id": "4",
        "arquivo": "RC Contraparte - parte 2",
        "path": caminhoArquivo(7, "RC Contraparte - parte 2.pdf"),
        "type": "pdf"
    },
    {
        "id": "5",
        "arquivo": "Quiz – Risco de Crédito de Contraparte (CCR)",
        "path": "https://forms.office.com/r/HxW8LVc4Ei",
        "type": "link"
    },
]

export const moduloOito = [
    {
        "id": "1",
        "arquivo": "Modulo8_Gestao_de_Capital_C2P_dia02.pptx",
        "path": caminhoArquivo(8, "Modulo8_Gestao_de_Capital_C2P_dia02.pptx"),
        "type": "pptx"
    },
    {
        "id": "2",
        "arquivo": "Modulo8_Gestao_de_Capital_C2P_dia_03.pptx",
        "path": caminhoArquivo(8, "Modulo8_Gestao_de_Capital_C2P_dia_03.pptx"),
        "type": "pptx"
    },
    {
        "id": "3",
        "arquivo": "BALANCO_PASSO_PASSO.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/BALANCO_PASSO_PASSO.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "4",
        "arquivo": "BRGAAP_Itau_1T26_Balanco_DRE_titulos.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/BRGAAP_Itau_1T26_Balanco_DRE_titulos.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "5",
        "arquivo": "BRGAAP_Itau_1T26_Balanco_DRE_titulos_1.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/BRGAAP_Itau_1T26_Balanco_DRE_titulos_1.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "6",
        "arquivo": "Balanco 01.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/Balanco 01.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "7",
        "arquivo": "Basel3_Finalaising2017.pdf",
        "path": caminhoArquivo(8, "materiais-apoio/Basel3_Finalaising2017.pdf"),
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "EVE_NII_K_abaixoeacima12m_v02.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/EVE_NII_K_abaixoeacima12m_v02.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "9",
        "arquivo": "Gerenciamento de riscos e capital - Pilar 3 - 1T26.pdf",
        "path": caminhoArquivo(8, "materiais-apoio/Gerenciamento de riscos e capital - Pilar 3 - 1T26.pdf"),
        "type": "pdf"
    },
    {
        "id": "10",
        "arquivo": "IFRS_Itau_Balanco_DRE_titulos.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/IFRS_Itau_Balanco_DRE_titulos.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "11",
        "arquivo": "Leiautes das tabelas do Relatorio de Pilar 3.docx",
        "path": caminhoArquivo(8, "materiais-apoio/Leiautes das tabelas do Relatorio de Pilar 3.docx"),
        "type": "docx"
    },
    {
        "id": "12",
        "arquivo": "Limitesoperacionais.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/Limitesoperacionais.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "13",
        "arquivo": "Modelo_ICAAP_Balanco_DRE_Capital.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/Modelo_ICAAP_Balanco_DRE_Capital.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "14",
        "arquivo": "Pilar_3_MercadoPago.pdf",
        "path": caminhoArquivo(8, "materiais-apoio/Pilar_3_MercadoPago.pdf"),
        "type": "pdf"
    },
    {
        "id": "15",
        "arquivo": "balanco_DRE.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/balanco_DRE.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "16",
        "arquivo": "custo_bene_hedge_IRRBB.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/custo_bene_hedge_IRRBB.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "17",
        "arquivo": "dados_SFN_2025.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/dados_SFN_2025.xlsx"),
        "type": "xlsx"
    },
    {
        "id": "18",
        "arquivo": "demonstracoes_contabeis_completas_em_ifrs_ajuste_parecer_auditoria.pdf",
        "path": caminhoArquivo(8, "materiais-apoio/demonstracoes_contabeis_completas_em_ifrs_ajuste_parecer_auditoria.pdf"),
        "type": "pdf"
    },
    {
        "id": "19",
        "arquivo": "questoes_estudo_caso.xlsx",
        "path": caminhoArquivo(8, "materiais-apoio/questoes_estudo_caso.xlsx"),
        "type": "xlsx"
    },
]
